<button class="menu btn btn-light" *ngFor="let menuItem of menu">
        <a target="_blank" routerLink="{{ menuItem.menuLink }}{{ menuItem.itemId }}">
            <i class="bi bi-window-stack"></i>
            {{ menuItem.menuText }}
        </a>
</button>